module.exports = "<div class=modal-header> <button type=button class=close ng-click=$ctrl.dismiss()> <span aria-hidden=true>&times;</span> </button> <h5 class=modal-title style=font-size:20px;font-weight:500>Ошибки</h5> </div> <div class=modal-body> <div class=\"alert alert-danger\"> <ul> <li ng-repeat=\"message in $ctrl.client.errorMessages\"> {{ message }} </li> </ul> </div> </div> <div class=modal-footer> <button type=button class=\"btn btn-secondary\" ng-click=$ctrl.dismiss()>Закрыть</button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/modules/components/client-import-error-messages/client-import-error-messages.html
// module id = kXcZ
// module chunks = 1